<template>
  <div>
    <van-nav-bar title="异常考勤统计" left-text="" right-text="" @click-right=""/>
    <van-cell-group inset v-for="item in errorData" :title="item.deptName">
      <van-cell title="考勤人数" icon="friends-o">
        <template #value>
          <van-tag type="primary" plain >{{item.attendanceNumber}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="迟到天数" icon="tosend">
        <template #value>
          <van-tag type="danger" plain >{{item.beLateNumber}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="早退天数" icon="tosend">
        <template #value>
          <van-tag type="danger" plain >{{item.leaveEarlyNumber}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="旷工天数" icon="warn-o">
        <template #value>
          <van-tag type="danger" plain >{{item.absenteeismNumber}}</van-tag>
        </template>
      </van-cell>
    </van-cell-group>
    <!--    <van-row class="cus-table">-->
    <!--      <van-col span="3"><van-tag  type="primary">序号</van-tag></van-col>-->
    <!--      <van-col span="5"><van-tag  type="primary">部门</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag  type="primary">考勤人数</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag  type="primary">迟到天数</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag  type="primary">早退天数</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag  type="primary">旷工天数</van-tag></van-col>-->
    <!--    </van-row>-->
    <!--    <van-row v-for="item in errorData" class="cus-table">-->
    <!--      <van-col span="3"><van-tag plain round type="primary">{{ count ++ }}</van-tag></van-col>-->
    <!--      <van-col span="5"><van-tag size="5" plain type="primary">南京智慧水务科技有限公司领导</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag plain type="primary">{{ item.attendanceNumber }}</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag plain type="danger">{{ item.beLateNumber }}</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag plain type="danger">{{ item.leaveEarlyNumber }}</van-tag></van-col>-->
    <!--      <van-col span="4"><van-tag plain type="danger">{{ item.absenteeismNumber }}</van-tag></van-col>-->
    <!--    </van-row>-->
  </div>
</template>

<script>

import {isLogin} from "../../../utils/util";

export default {
  name: "ErrorAttendance",
  data() {

    return {
      deptNo: '',
      currentYear: "",
      currentMonth: "",
      currentDay: "",
      beginTime: "",
      endTime: "",
      errorData: [],
      count: 1,
    };
  },
  mounted() {
    if (!isLogin()) {
      this.$router.push({
        path: "/attenceflow/Error",
        query: {}
      });
    }

    this.$fetch("/attence-api/blade-user/info", {}).then(
      res => {
        const data = res.data;
        this.nickname = data.name;
        this.account = data.account;
        this.deptNo = data.deptId;
        console.log("返回的数据：" + JSON.stringify(data));
        this.loadData();
      },
      error => {

      }
    );
  },
  methods: {
    jumpPage: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    loadData() {
      this.currentDay = new Date().getDate();
      this.currentYear = new Date().getFullYear();
      this.currentMonth = new Date().getMonth() + 1;
      if (this.currentMonth < 10) {
        this.currentMonth = `0${this.currentMonth}`;
      }
      this.beginTime = `${this.currentYear}-${this.currentMonth}-01`;
      this.endTime = `${this.currentYear}-${this.currentMonth}-${this.currentDay}`;
      this.$post("/attence-api/blade-attendance-info/attendanceInfo/attendanceAnomalyStatistics", {
        deptNo: this.deptNo,
        begin: this.beginTime,
        end: this.endTime
      }).then(
        res => {
          const data = res.data;
          this.errorData = data;
          console.log("返回的数据：" + JSON.stringify(data));
        },
        error => {

        }
      );
    }
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

. cus-table {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/wel/ErrorAttendance.vue